import React, { useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import CampaignIcon from "../../assets/icons/create_inbound.svg2";
import HelpButton from "../HelpContent/HelpButton";
import MyModal from "../Common/MyModal";
import WorkflowInbounds from "../Inbounds/WorkflowInbounds";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";

function CreateACampaignDropdown() {
  const [show, setShow] = useState(false);
  return (
    <div>
      <Dropdown onToggle={setShow} show={show}>
        <button
          type="button"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setShow((p) => !p);
          }}
          className="btn btn-sm bg-purple-gradient rounded-3 text-purple text-small fw-bold w-100"
        >
          Start with a..{" "}
          <FontAwesomeIcon icon={faChevronDown} className="float-end mt-1" />
        </button>
        <Dropdown.Menu className="bg-purple-gradient">
          <Dropdown.Item>
            <MyModal
              size="xxl"
              label={
                <div className="d-flex align-items-center justify-content-between gap-3">
                  <div className="d-flex">
                    <CampaignIcon width={30} />
                  </div>
                  <div>
                    <h5 className="fw-bold text-purple text-start">
                      Campaign library
                    </h5>
                    <span className="text-secondary">
                      Use or edit existing Campaign
                    </span>
                  </div>
                  <HelpButton helpKey="campaign-library" />
                </div>
              }
              buttonClassName=" rounded-4 start text-black border-0 "
              modalClassName="bg-purple-gradient"
            >
              <WorkflowInbounds isModal />
            </MyModal>
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
}

export default CreateACampaignDropdown;
